import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import client from './adminApi';

const AdminAuthContext = createContext(null);

// Three states: undefined = checking, null = signed out, object = signed in.
export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    client.get('/admin/auth/me')
      .then((res) => setUser(res.data.user))
      .catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await client.post('/admin/auth/login', { email, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await client.post('/admin/auth/logout'); } catch { /* cookie cleared regardless */ }
    setUser(null);
  }, []);

  const logoutAll = useCallback(async () => {
    try { await client.post('/admin/auth/logout-all'); } catch { /* ignore */ }
    setUser(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ user, login, logout, logoutAll }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}

export const ROLE_LABELS = {
  owner: 'Owner',
  administrator: 'Administrator',
  editor: 'Editor',
};
